module.exports = {"version":"v1","limitedLocales":["es"]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/@os/finance-model/config/default/config.json
// module id = 1049
// module chunks = 0